/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const IntersectOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m11.48 9.23 3.29 3.29m-5.54-1.04 3.29 3.29M15.75 9c0 3.73-3.02 6.75-6.75 6.75S2.25 12.73 2.25 9 5.27 2.25 9 2.25 15.75 5.27 15.75 9zm6 6c0 3.73-3.02 6.75-6.75 6.75S8.25 18.73 8.25 15 11.27 8.25 15 8.25s6.75 3.02 6.75 6.75z"
})));
// Fill
const IntersectFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M16.37 7.63a7.56 7.56 0 0 0-1.77-3.62 7.53 7.53 0 0 0-3.38-2.18c-1.31-.4-2.7-.45-4.02-.12A7.51 7.51 0 0 0 1.71 7.2c-.33 1.32-.28 2.71.12 4.02a7.53 7.53 0 0 0 2.18 3.38 7.56 7.56 0 0 0 3.62 1.77 7.56 7.56 0 0 0 1.77 3.62 7.584 7.584 0 0 0 3.38 2.18c1.31.4 2.7.45 4.02.12a7.51 7.51 0 0 0 5.49-5.49c.33-1.32.28-2.71-.12-4.02a7.53 7.53 0 0 0-2.18-3.38 7.56 7.56 0 0 0-3.62-1.77zM3 9c0-1.46.53-2.87 1.5-3.97s2.3-1.8 3.75-1.99c1.45-.18 2.92.17 4.12 1a5.96 5.96 0 0 1 2.44 3.47c-1.92.05-3.75.83-5.11 2.19s-2.14 3.19-2.19 5.11a6.015 6.015 0 0 1-3.25-2.13A6.067 6.067 0 0 1 3 9zm12 12c-1.33 0-2.62-.45-3.68-1.26a6.015 6.015 0 0 1-2.13-3.25c1.92-.05 3.75-.83 5.11-2.19s2.14-3.19 2.19-5.11a5.96 5.96 0 0 1 3.47 2.44c.83 1.2 1.18 2.67 1 4.12-.19 1.45-.89 2.78-1.99 3.75S16.46 21 15 21z"
})));
// DuoTone
const IntersectDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M8.25 15c0 .23.05.45.07.68.23.02.45.07.68.07 1.79 0 3.51-.71 4.77-1.98A6.719 6.719 0 0 0 15.75 9c0-.23-.05-.45-.07-.68-.23-.02-.45-.07-.68-.07-1.79 0-3.51.71-4.77 1.98A6.719 6.719 0 0 0 8.25 15z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("g", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 15.75c3.73 0 6.75-3.02 6.75-6.75S12.73 2.25 9 2.25 2.25 5.27 2.25 9 5.27 15.75 9 15.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 21.75c3.73 0 6.75-3.02 6.75-6.75S18.73 8.25 15 8.25 8.25 11.27 8.25 15s3.02 6.75 6.75 6.75z"
}))));
/**
  Icon IntersectIcon in design group
*/
export const IntersectIcon = createIcon('IntersectIcon', 'intersect', 'design', IntersectOutline, IntersectFill, IntersectDuotone, "0 0 24 24");